import React from 'react'
import {} from 'mailup-web-components'
import { useIntl } from 'react-intl'
import RecipientsSummary from './RecipientsSummary'

const RecipientsSelectionAllTab = () => {
  const intl = useIntl()

  return (
    <>
      <RecipientsSummary />
    </>
  )
}

export default RecipientsSelectionAllTab
